var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader_wrapper"}},[_c('van-loading',{attrs:{"type":"spinner","color":"#fff","size":"40","vertical":""}},[_vm._v(_vm._s(_vm.$store.state.loadingText?_vm.$store.state.loadingText:'加载中...'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }